export const PROVIDERS_REQUESTED = 'PROVIDERS_REQUESTED'
export const PROVIDERS_RECEIVED = 'PROVIDERS_RECEIVED'

export const PROVIDERS_PRINT_REQUESTED = 'PROVIDERS_PRINT_REQUESTED'
export const PROVIDERS_PRINT_RECEIVED = 'PROVIDERS_PRINT_RECEIVED'

export const PROVIDER_NAME_LIST_REQUESTED = 'PROVIDER_NAME_LIST_REQUESTED'
export const PROVIDER_NAME_LIST_RECEIVED = 'PROVIDER_NAME_LIST_RECEIVED'
export const PROVIDER_NAME_LIST_RESET = 'PROVIDER_NAME_LIST_RESET'
export const SPECIALITY_LIST_REQUESTED = 'SPECIALITY_LIST_REQUESTED'
export const SPECIALITY_LIST_RECEIVED = 'SPECIALITY_LIST_RECEIVED'

export const PROVIDER_REQUESTED = 'PROVIDER_REQUESTED'
export const PROVIDER_RECEIVED = 'PROVIDER_RECEIVED'
export const PROVIDER_PCP_REQUESTED = 'PROVIDER_PCP_REQUESTED'
export const PROVIDER_PCP_RECEIVED = 'PROVIDER_PCP_RECEIVED'

export const PROVIDER_AUTH_RECEIVED = 'PROVIDER_AUTH_RECEIVED'

export const UPDATE_PCP_REQUESTED = 'UPDATE_PCP_REQUESTED'
export const UPDATE_PCP_RECEIVED = 'UPDATE_PCP_RECEIVED'
export const UPDATE_PCP_FAILED = 'UPDATE_PCP_FAILED'

export const PROVIDERS_SEARCH_REQUESTED = 'PROVIDERS_SEARCH_REQUESTED'
export const PROVIDERS_SEARCH_RESULTS_RECEIVED =
  'PROVIDERS_SEARCH_RESULTS_RECEIVED'
export const PROVIDERS_SEARCH_FAILED = 'PROVIDERS_SEARCH_FAILED'

export const PROVIDERS_SUGGESTIONS_REQUESTED = 'PROVIDERS_SUGGESTIONS_REQUESTED'
export const PROVIDERS_SUGGESTIONS_RESULTS_RECEIVED =
  'PROVIDERS_SUGGESTIONS_RESULTS_RECEIVED'
export const PROVIDERS_SUGGESTIONS_FAILED = 'PROVIDERS_SUGGESTIONS_FAILED'

export const PROVIDER_DETAILS_REQUESTED = 'PROVIDER_DETAILS_REQUESTED'
export const PROVIDER_DETAILS_RECEIVED = 'PROVIDER_DETAILS_RECEIVED'

export const SEARCH_BY_LOCATION_UPDATED = 'SEARCH_BY_LOCATION_UPDATED'
export const SEARCH_PROVIDER_FILTERS_UPDATED = 'SEARCH_PROVIDER_FILTERS_UPDATED'
export const PROVIDERS_SEARCH_QUERY_UPDATED = 'PROVIDERS_SEARCH_QUERY_UPDATED'
export const SEARCH_PROVIDERS_PDF_REQUESTED = 'SEARCH_PROVIDERS_PDF_REQUESTED'
export const SEARCH_PROVIDERS_PDF_RECEIVED = 'SEARCH_PROVIDERS_PDF_RECEIVED'
export const CHANGE_PCP_SELECTED_PROVIDER_ID = 'CHANGE_PCP_SELECTED_PROVIDER_ID'
